<template>
  <div class="balance py-6 px-8">
    <h-header back="../customers">
      <template v-slot:actions>
        <v-btn
          @click="() => openCreateEditModal()"
          color="primary"
          target="_blank"
          elevation="0"
        >
          <v-icon left>
            mdi-plus
          </v-icon>
          <span class="d-none d-md-flex body-2">
            {{ $t('realEstate.actions.create') }}
          </span>
        </v-btn>
      </template>
    </h-header>
    <v-card outlined>
      <v-data-table
        disable-sort
        hide-default-footer
        mobile-breakpoint="20"
        :headers="headers"
        :items="branches"
        :loading="isLoading"
        :items-per-page="itemsPerPage"
        :no-data-text="$t('appointment.table.noData')"
        :loading-text="$t('appointment.table.loading')"
      >
        <template v-slot:[`item.city`]="{ item }">
          {{ item.city.name }}
        </template>
        <template v-slot:[`item.is_headquarter`]="{ item }">
          <v-chip class="grey lighten-2" v-if="isHeadquarter(item)">
            {{ $t("customer.branches.label.isHeadquarter")}}
          </v-chip>
        </template>
        <template v-slot:[`item.actions`]="{ item }">
          <div class="d-flex justify-end">
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  @click="openCreateEditModal(item.id)"
                  v-bind="attrs" v-on="on"
                  icon
                >
                  <v-icon small>
                    mdi-pencil
                  </v-icon>
                </v-btn>
              </template>
              <span>{{ $t("customer.branches.actions.edit") }}</span>
            </v-tooltip>
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <div v-bind="attrs" v-on="on">
                  <v-btn
                    @click="openConfirmDeleteModal(item)"
                    :disabled="isHeadquarter(item)"
                    icon
                  >
                    <v-icon small>
                      mdi-delete
                    </v-icon>
                  </v-btn>
                </div>
              </template>
              <span>
                {{
                  isHeadquarter(item)
                    ? $t('customer.branches.hint.headquarterCannotBeDeleted')
                    : $t('customer.branches.actions.delete')
                }}
              </span>
            </v-tooltip>
          </div>
        </template>
      </v-data-table>
    </v-card>

    <h-pagination :fetch="fetchBranchesAsAdmin" :fetchParams="[id]" />

    <AdminCreateUpdateBranch ref="createModal" />
    <ModalCustomContract ref="modalCustomContract" />
    <ModalBranchConfirmDelete
      ref="modalBranchConfirmDelete"
      migrates-users-to-headquarter
      @confirm="callbackDelete"
    />
  </div>
</template>

<script>
import store from '@/store'
import ModalCustomContract from '@/components/customer/modals/ModalCustomContract'
import AdminCreateUpdateBranch from '@/components/branch/AdminCreateUpdateBranch'
import ModalBranchConfirmDelete from '@/components/branch/ModalBranchConfirmDelete'
import { realEstateBranchHeaders } from './listHeaders/realEstateBranchHeaders'
import { mapGetters, mapActions, mapMutations } from 'vuex'
import { catalogDate } from '@/util/catalog'

export default {
  name: 'RealEstateBranchList',
  components: {
    ModalCustomContract,
    AdminCreateUpdateBranch,
    ModalBranchConfirmDelete
  },

  data() {
    return {
      id: this.$router.currentRoute.params.id,
      formatDate: catalogDate,
      headers: realEstateBranchHeaders,
    }
  },

  computed: {
    ...mapGetters(['isLoading', 'branches', 'itemsPerPage', 'customer']),
  },

  methods: {
    ...mapActions([
      'fetchBranchesAsAdmin',
      'fetchBranchAsAdmin',
      'fetchCustomer',
      'deleteBranch',
      'openModal'
    ]),
    ...mapMutations(['setBranch', 'setFilters']),

    // /admin/branch/delete refuses the headquarter and moves the users of the branch to it, same as the
    // client side, so the list has to disable the action and the modal has to warn about the migration.
    isHeadquarter(branch) {
      return Boolean(this.customer.headquarter && this.customer.headquarter.id === branch.id)
    },

    showDetails(id) {
      this.$router.push(`/contract-details/${id}`)
    },

    async callbackDelete(branch) {
      await this.deleteBranch(branch.id)
      this.fetchBranches()
    },

    openConfirmDeleteModal(branch) {
      this.$refs.modalBranchConfirmDelete.openConfirmModal(branch)
    },

    openCreateEditModal(id) {
      this.setBranch({})
      this.openModal('CREATE_UPDATE_BRANCH_MODAL')
      if (id) this.fetchBranchAsAdmin(id).then(() => this.$refs.createModal.fillFields())
    },

    async fetchBranches() {
      var mappedParams = {
        realEstateId: this.id
      }
      Promise.resolve(
        this.setFilters({ ...store.getters.filters, ...mappedParams })
      ).then(() => {
        this.fetchBranchesAsAdmin()
      })
    },
  },

  async mounted() {
    if (!this.id) return
    await this.fetchCustomer(this.id)
    this.fetchBranches()
  }
}
</script>
